const fontFmily = 
["ABeeZee",
"Abel",
"Aclonica",
"Acme",
"Aguafina Script",
"Akronim",
"Aladin",
"Alegreya SC",
"Alex Brush",
"Allura",
"Almendra",
"Almendra Display",
"Amatic SC",
"Amita",
"Arizonia",
"Arimo",
"Arvo",
"Asap Condensed",
"Bad Script",
"Balsamiq Sans",
"Barrio",
"Berkshire Swash",
"Bubblegum Sans",
"Bungee Hairline",
"Butcherman",
"Catamaran",
"Dancing Script",
"Do Hyeon",
"Dokdo",
"Dosis",
"Dr Sugiyama",
"Eater",
"Ewert",
"Fascinate Inline",
"Faster One",
"Finger Paint",
"Gorditas",
"Great Vibes",
"Habibi",
"Hanuman",
"Hanalei",
"IM Fell Great Primer SC",
"Iceberg",
"Iceland",
"Indie Flower",
"Inter",
"Irish Grover",
"Italianno",
"Itim",
"Jacques Francois",
"Jacques Francois Shadow",
"Jim Nightshade",
"Joti One",
"Julius Sans One",
"Just Me Again Down Here",
"Kaushan Script",
"Keania One",
"Kirang Haerang",
"Kite One",
"Kristi",
"Kumar One Outline",
"Lakki Reddy",
"Leckerli One",
"Lily Script One",
"Liu Jian Mao Cao",
"Londrina Shadow",
"Love Ya Like A Sister",
"Major Mono Display",
"Mandali",
"Marck Script",
"Merienda",
"Merienda One",
"Merriweather Sans",
"Michroma",
"Miltonian Tattoo",
"Mountains of Christmas",
"Mukta Vaani",
"Niramit",
"Nosifer",
"Nova Script",
"Norican",
"Offside",
"Orbitron",
"PT Sans Caption",
"Pacifico",
"Palanquin Dark",
"Piedra",
"Playfair Display",
"Poiret One",
"Princess Sofia",
"Zilla Slab",
"Zhi Mang Xing",
"Zeyada",
"ZCOOL XiaoWei",
"ZCOOL KuaiLe",
"Yeon Sung",
"Yellowtail",
"Yatra One",
"Yanone Kaffeesatz",
"Yesteryear",
"Wire One",
"Wendy One",
"Wellfleet",
"Warnes",
"Walter Turncoat",
"Wallpoet",
"Waiting for the Sunrise",
"Volkhov",
"Viga",
"Vibur",
"Vibes",
"Vast Shadow",
"Vampiro One",
"VT323",
"Unlock",
"Unkempt",
"UnifrakturMaguntia",
"Unica One",
"Underdog",
"Uncial Antiqua",
"Ultra",
"Ubuntu",
"Ubuntu Mono",
"Turret Road",
"Turret Road",
"Tulpen One",
"Trochut",
"Trocchi",
"Trade Winds",
"Tomorrow",
"Titan One",
"Timmana",
"Tillana",
"The Girl Next Door",
"Text Me One",
"Tenali Ramakrishna",
"Tauri",
"Tangerine",
"Syncopate",
"Swanky and Moo Moo",
"Suravaram",
"Supermercado One",
"Sunshiney",
"Sulphur Point",
"Sue Ellen Francisco",
"Stylish",
"Stint Ultra Expanded",
"Stardos Stencil",
"Stalinist One",
"Stalemate",
"Srisakdi",
"Sriracha",
"Spirax",
"Spicy Rice",
"Special Elite",
"Space Mono",
"Source Code Pro",
"Sonsie One",
"Sofia",
"Sofadi One",
"Snowburst One",
"Snippet",
"Sniglet",
"Smokum",
"Slackey",
"Skranji",
"Six Caps",
"Sirin Stencil",
"Simonetta",
"Sigmar One",
"Shrikhand",
"Short Stack",
"Shojumaru",
"Shadows Into Light Two",
"Shadows Into Light",
"Seymour One",
"Sevillana",
"Sedgwick Ave Display",
"Sedgwick Ave",
"Seaweed Script",
"Satisfy",
"Sarina",
"Sancreek",
"Saira Stencil One",
"Sail",
"Sacramento",
"Rye",
"Ruthie",
"Ruslan Display",
"Rum Raisin",
"Ruge Boogie",
"Rubik Mono One",
"Rouge Script",
"Rosarivo",
"Romanesco",
"Rock Salt",
"Rochester",
"Roboto",
"Risque",
"Ribeye Marrow",
"Ribeye",
"Revalia",
"Reenie Beanie",
"Redressed",
"Red Rose",
"Ravi Prakash",
"Ranga",
"Rancho",
"Ranchers",
"Raleway Dots",
"Rakkas",
"Rajdhani",
"Racing Sans One",
"Quintessential",
"Qwigley",
"Quicksand"];
export default fontFmily;
